import {
  TICKETS_SET_TICKETS,
  TICKETS_SET_SEARCH_STRING,
  TICKETS_TOGGLE_LOADING,
  ITicketsResetStore,
  TICKETS_RESET_STORE,
  TICKETS_SET_FILTER_STRING,
  ITicketsSetFilter,
  TICKETS_TOGGLE_NEW_TICKET_DROPDOWN,
  ITogglTicketsFilterDropdownAction,
  TICKETS_TOGGLE_FILTER_DROPDOWN,
  TICKETS_ADD_TICKET_TO_TICKETS, TICKETS_ESCALATE_TICKET,
} from './types';
import { api_getTicketList } from '../../utils/Tickets/Tickets';
import { setSystemError } from '../system/actions';
import { defaultErrorFeedback } from '../../actions/feedback';

export const resetTicketsStore = (): ITicketsResetStore => ({ type: TICKETS_RESET_STORE });
export const setTicketsFilter = (payload): ITicketsSetFilter => ({ type: TICKETS_SET_FILTER_STRING, payload });
export const toggleTicketsFilterDropdown = (): ITogglTicketsFilterDropdownAction => ({ type: TICKETS_TOGGLE_FILTER_DROPDOWN });
export function toggleAccountTicketsLoading() {

  return {
    type: TICKETS_TOGGLE_LOADING,
  };

}
export function toggleNewTicketsDropdown() {

  return {
    type: TICKETS_TOGGLE_NEW_TICKET_DROPDOWN,
  };

}
export function setTicketsSearchString(search) {

  return {
    type: TICKETS_SET_SEARCH_STRING,
    search,
  };

}
function setAccountTickets(tickets) {

  return {
    type: TICKETS_SET_TICKETS,
    tickets,
  };

}
export function getAccountTickets() {

  return (dispatch) => api_getTicketList().then((result) => {

    if (result.status === 200) {

      dispatch(setAccountTickets(result.data));

    } else if (result.data.error && result.data.error.id) {

      dispatch(setSystemError(result.data.error.id));

    } else {

      dispatch(defaultErrorFeedback());

    }

  });

}

export const addTicketToTickets = (theTicket) => ({ type: TICKETS_ADD_TICKET_TO_TICKETS, theTicket });
export const escalateTicketInTickets = (id) => ({ type: TICKETS_ESCALATE_TICKET, id });
